import { useState, useEffect, RefObject } from 'react';

const useScrolableContentHook = (tabRef: RefObject<HTMLUListElement>) => {
  const [scrolableContent, setScrollableContent] = useState({
    isScrollable: 'DEFAULT',
    scrollWidth: 0,
  });

  const reset = async () => setScrollableContent({ isScrollable: 'DEFAULT', scrollWidth: 0 });

  const checkScrollable = () => {
    setTimeout(() => {
      if (tabRef.current) {
        const scrollWidth = tabRef.current.scrollWidth;
        const clientWidth = tabRef.current.clientWidth;
        setScrollableContent({
          isScrollable: scrollWidth > clientWidth ? 'SCROLLABLE' : 'NOT_SCROLLABLE',
          scrollWidth,
        });
      }
    }, 1000);
  };

  const resizeEvent = async () => {
    await reset();
    checkScrollable();
  };

  useEffect(() => {
    // Call the function initially
    checkScrollable();

    // Add event listener on mount
    window.addEventListener('resize', resizeEvent);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('resize', resizeEvent);
    };
  }, []);

  return scrolableContent;
};

export default useScrolableContentHook;
